import React, { useState, useEffect } from "react";

import { Form, Table, Empty } from "antd";
import arrowDown from "../assets/icons/eua/arrow-down.svg";
import { useSelector, useDispatch } from "react-redux";
import { getEuaOutstanding, getSettlementDues } from "../features/EUA/EuaSlice";
import "../css/notifications.css";
import ClipboardText from "../assets/icons/voyages/clipboard-text.svg"
import { fetchHistoryOrderDetails, fetchPrefilledOrderDetails } from "../features/Voyage/VoyageSlice";
import OrderModal from "../container/Invoice/OrderModal";

const ExpandedRowRender = ({ onSelectRow, ...props }) => {

  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // ✅ MOVE HOOKS TO TOP LEVEL
  const [vesselName, setVesselName] = useState('');
  const [isOrderModalVisible, setOrderModalVisible] = useState(false);

  // ✅ KEEP FUNCTION CLEAN
  const handleSettlementFetch = (record) => {
    if (record?.imo_number) {
      dispatch(getSettlementDues(record.imo_number));
    }
  };

  // ✅ NOW THIS IS PROPERLY SCOPED
  const openOrderModal = (record) => {
    dispatch(fetchPrefilledOrderDetails(record)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(fetchHistoryOrderDetails(record));
        setVesselName(record?.Vessel);
        setOrderModalVisible(true);
      }
    });
  };

  const closeOrderModal = () => {
    setOrderModalVisible(false);
  };

  const columns = [
    {
      title: "Vessel Name",
      dataIndex: "Vessel",
      className: "custom-column",
    },
    {
      title: "EUA's",
      dataIndex: "EU-ETS",
      render: (value) => `${value || '0.00'}`,
      className: "customs-column",
    },
    {
      title: "UKA's",
      dataIndex: "UK-ETS",
      render: (value) => `${value || '0.00'}`,
            className: "customs-column",

    },
    {
      title: "FEUM",
      dataIndex: "FEUM",
      render: (value) => `€${value || '0.00'}`,
            className: "customs-column",

    },
    {
      title: "IMO GFI",
      dataIndex: "IMO GFI",
      render: (value) => `$${value || '0.00'}`,
            className: "customs-column",

    },
    {
      title: "Order",
      dataIndex: "Order",
                  className: "customs-column",


      render: (_, record) =>
       (
          <div onClick={() => openOrderModal(record)} style={{ cursor: 'pointer' }}>
            <img src={ClipboardText} style={{ height: '20px' }} alt="" />
          </div>
        ) 
    }
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(
      props.data.map((value, index) => ({
        key: index.toString(),
        Vessel: value.vessel_name || '-',
        "EU-ETS": (value.eu_ets || 0).toFixed(2),
        "UK-ETS": (value.uka || 0).toFixed(2),
        "FEUM": (value.penalty || 0).toFixed(2),
        "IMO GFI": ((value.t1 || 0) + (value.t2 || 0)).toFixed(2),
        "EE Metier": (value.eeoi || 0).toFixed(2),
        "imo_number": value.imo_number,
      })).sort((a, b) => a.Vessel.localeCompare(b.Vessel))
    );
  }, [props.data]);

  return (
    <>
      <Table
        className="expandable-table-settlement"
        scroll={{ y: "38vh" }}
        columns={columns}
        dataSource={data}
        pagination={false}
        onRow={(record) => ({
          onClick: () => onSelectRow(record.imo_number),
        })}
      />

      {/* ✅ Modal FIX */}
      <OrderModal
        visible={isOrderModalVisible}
        onClose={closeOrderModal}
        vesselName={vesselName}
      />
    </>
  );
};

const ExpandableRow = ({ onSelectRow, ...props }) => {
  const { activeCard, setActiveCard } = props;

  const handleClick = () => {
    setActiveCard(props.title === activeCard ? null : props.title);
  };

  return (
    <div className="admin-table">
      <div onClick={handleClick} className="ExpandRow-Sattlement">
        <img src={arrowDown} alt="" />
        <span>{props.title}</span>
      </div>
      <div
        className="content"
        style={{
          maxHeight: props.title === activeCard ? '45vh' : '0',
          overflow: "hidden",
          transition: 'max-height 0.4s ease-out',
        }}
      >
        <ExpandedRowRender data={props.data} onSelectRow={onSelectRow} />
      </div>
    </div>
  );
}

const ExpandableTable = (props) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([])
  const [activeCard, setActiveCard] = useState("");
  const [imoNumbers, setImoNumbers] = useState([]);
  const [selectedImo, setSelectedImo] = useState(null);
  const dispatch = useDispatch()

 useEffect(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) return;

  const ownerVessels = {};

  props.data.forEach(entry => {
    const owner = entry.active_owner;
    if (!ownerVessels[owner]) {
      ownerVessels[owner] = [];
    }
    ownerVessels[owner].push(entry);
  });

  const sortedOwners = Object.keys(ownerVessels).sort();

  const sortedData = {};
  sortedOwners.forEach(owner => {
    sortedData[owner] = ownerVessels[owner];
  });

  setData(sortedData);

  if (!activeCard && sortedOwners.length > 0) {
    setActiveCard(sortedOwners[0]);
  }
}, [props.data, activeCard]);

  useEffect(() => {
    if (activeCard) {
      const imoList = data[activeCard]?.map((entry) => entry.imo_number) || [];
      setImoNumbers(imoList);
      dispatch(getEuaOutstanding({ imo_numbers: imoList }))
    }
  }, [activeCard, data]);

  const handleRowSelect = (imoNumber) => {
    setSelectedImo(imoNumber);
    dispatch(getEuaOutstanding({ imo_numbers: [imoNumber] }))
  };

  return (
    <Form form={form} component={false}>
      <div className="expandable-table-height">
        {Object.keys(data).length === 0 ? <Empty /> : ""}
        {Object.keys(data).map((value, index) => {
          return <ExpandableRow 
            title={value} 
            activeCard={activeCard} 
            setActiveCard={setActiveCard} 
            data={data[value]} 
            key={index} 
            onSelectRow={handleRowSelect} 
          />
        })}
      </div>
    </Form>
  );
};

export default ExpandableTable;